<div class="itinerary-list">
    @if (!isVerticalWrapper) {
        <div class="itinerary-list__header">
            <h2 [class.sm]="!!title">
                @if (title) {
                    {{ title }}
                } @else {
                    {{ 'DESTINATION.POPULAR_TRIPS_IN' | translate: {country: countryName | replaceStr: ' ' | titlecase} }}
                }
            </h2>

            @if (!isFetching) {
                <a (click)="seeAll($event)" class="itinerary-list__see-all">
                    See all
                </a>
            }
        </div>
    }

    <div class="itinerary-list__content">
        @if (isFetching) {
            <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
                <div class="swiper-wrapper">
                    @for (hotel of [1, 2, 3, 4, 5, 6, 7]; track hotel; let idx = $index) {
                        <div class="swiper-slide">
                            <app-itinerary-card-mobile
                                    [isFetching]="isFetching"
                            ></app-itinerary-card-mobile>
                        </div>
                    }
                </div>
            </div>
        } @else {
            <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
                <div class="swiper-wrapper">
                    @for (itinerary of itineraries; track itinerary.saves_id; let idx = $index) {
                        <div class="swiper-slide">
                            <app-itinerary-card-mobile
                                    [itinerary]="itinerary"
                                    (makeItMyPlan)="onMakeItMyTripPlanHandler($event)"
                            ></app-itinerary-card-mobile>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>
